export default __webpack_public_path__ + "static/media/purchase.91be8d49.png";